import React from "react";
import { SVGProps } from "../../svgData";

export default ({ defaultColor, selectedColor, isSelected }: SVGProps) => {
  const color = isSelected ? selectedColor : defaultColor;

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="window-restore-regular 2">
        <path
          id="Vector"
          d="M19.3125 3H8.0625C7.13086 3 6.375 3.75586 6.375 4.6875V6.375H4.6875C3.75586 6.375 3 7.13086 3 8.0625V19.3125C3 20.2441 3.75586 21 4.6875 21H15.9375C16.8691 21 17.625 20.2441 17.625 19.3125V17.625H19.3125C20.2441 17.625 21 16.8691 21 15.9375V4.6875C21 3.75586 20.2441 3 19.3125 3ZM15.9375 19.3125H4.6875V12H15.9375V19.3125ZM19.3125 15.9375H17.625V8.0625C17.625 7.13086 16.8691 6.375 15.9375 6.375H8.0625V4.6875H19.3125V15.9375Z"
          fill={color}
        />
      </g>
    </svg>
  );
};
